import { gql } from '@apollo/client';

import NOTIFICATIONS_FRAGMENT from '../fragments/notifications';

export const GET_NOTIFICATIONS = gql`
  ${NOTIFICATIONS_FRAGMENT}
  query getNotifications($userId: String!) {
    getNotifications(id: $userId) {
      ...NotificationsFragment
    }
  }
`;
